import { ICoupon, ICouponApplied } from 'types/coupon';
import { getCouponType } from 'services/coupon/type';
import { couponTypeConst } from 'config/coupon';
import Big from 'big.js';

function getDiscountCouponAmount(coupon: ICouponApplied, amount: number) {
    let couponDiscount = Math.ceil(Big(amount).mul(Big(10).sub(coupon.discount)).div(10));
    if (coupon.maxDiscountLimit > 0 && couponDiscount > coupon.maxDiscountLimit) {
        return coupon.maxDiscountLimit;
    }
    if (amount < couponDiscount) {
        return amount;
    }

    // if (couponDiscount < 1) {
    //     return 1;
    // }

    return couponDiscount;
}

function getStraightReducedCouponAmount(coupon: ICouponApplied, amount: number) {
    if (amount < coupon.credit) return amount;

    return coupon.credit;
}

function getFullReducedCouponAmount(coupon: ICouponApplied, amount: number) {
    if (amount >= Number(coupon.threshold)) {
        return coupon.credit;
    }

    return 0;
}

export const computeCouponDiscount = (
    coupon: ICouponApplied | null | undefined,
    amount: number
) => {
    if (!coupon || amount === 0) {
        return 0;
    }

    const couponType = getCouponType(coupon);

    if (couponType === couponTypeConst.discount) {
        return getDiscountCouponAmount(coupon, amount);
    }

    if (couponType === couponTypeConst.straightReduced) {
        return getStraightReducedCouponAmount(coupon, amount);
    }

    if (couponType === couponTypeConst.fullDiscount) {
        return getFullReducedCouponAmount(coupon, amount);
    }

    return 0;
};
